var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Navbar'),_c('div',{staticClass:"row mt-5"},_vm._l((_vm.$store.state.products),function(product){return _c('Product',{key:product.id,attrs:{"product":product}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }